var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchway(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560 448H544V96H32V448H16C7.125 448 0 455.125 0 464V496C0 504.875 7.125 512 16 512H176C184.875 512 192 504.875 192 496V320C192 267 235 224 288 224S384 267 384 320V496C384 504.875 391.125 512 400 512H560C568.875 512 576 504.875 576 496V464C576 455.125 568.875 448 560 448ZM560 0H16C7.125 0 0 7.125 0 16V48C0 56.875 7.125 64 16 64H560C568.875 64 576 56.875 576 48V16C576 7.125 568.875 0 560 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchway);
export default __webpack_public_path__ + "static/media/archway.2cef29cd7d9f0c9789f205c9814c6a6b.svg";
export { ForwardRef as ReactComponent };